export default __webpack_public_path__ + "static/media/uniswap.8c5b56ae.png";